import React from 'react';
import img from '../images/mouvement.avif';
import { Link } from 'react-router-dom';
import { Helper } from '../static/helper';

const Intro = () => {
    return (
        <section aria-labelledby="intro-title" className="m-auto max-w-6xl p-4 md:p-12 h-5/6" id="about">
            <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="fade-up">
                <div className="w-full lg:w-1/2 flex flex-col lg:mx-4 justify-center items-center mt-6 lg:mt-0">
                    <img
                        alt="Illustration des bienfaits de la chiropraxie - mouvement et flexibilité"
                        className="rounded-xl w-full max-w-md h-auto object-cover shadow-lg"
                        src={img}
                        loading="lazy"
                        width="400"
                        height="300"
                    />
                </div>
                <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-4 lg:px-8" data-aos="zoom-in" data-aos-delay="500">
                    <h2 id="intro-title" className="mb-5 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold" style={{ color: Helper.footerBackGroundColor }}>
                        Les bénéfices de la chiropraxie
                    </h2>
                    <ul className="space-y-3" role="list">
                        <li className="flex items-center justify-center lg:justify-start gap-3 text-base sm:text-lg lg:text-xl text-gray-600 font-semibold">
                            <span className="text-green-500 text-xl" aria-hidden="true">✓</span>
                            Soulagement de la douleur
                        </li>
                        <li className="flex items-center justify-center lg:justify-start gap-3 text-base sm:text-lg lg:text-xl text-gray-600 font-semibold">
                            <span className="text-green-500 text-xl" aria-hidden="true">✓</span>
                            Amélioration de la mobilité et de la flexibilité
                        </li>
                        <li className="flex items-center justify-center lg:justify-start gap-3 text-base sm:text-lg lg:text-xl text-gray-600 font-semibold">
                            <span className="text-green-500 text-xl" aria-hidden="true">✓</span>
                            Alternative conservatrice à la chirurgie
                        </li>
                        <li className="flex items-center justify-center lg:justify-start gap-3 text-base sm:text-lg lg:text-xl text-gray-600 font-semibold">
                            <span className="text-green-500 text-xl" aria-hidden="true">✓</span>
                            Prévention des blessures
                        </li>
                        <li className="flex items-center justify-center lg:justify-start gap-3 text-base sm:text-lg lg:text-xl text-gray-600 font-semibold">
                            <span className="text-green-500 text-xl" aria-hidden="true">✓</span>
                            Amélioration de la qualité de vie
                        </li>
                    </ul>
                    <div className="w-full sm:w-72 pt-6 mx-auto lg:mx-0">
                        <Link
                            to="/EfficaciteetSoins"
                            style={{ background: Helper.footerBackGroundColor }}
                            className="text-white justify-center text-center rounded-xl px-10 py-3 flex items-center hover:opacity-90 transition-opacity font-semibold shadow-lg"
                            aria-label="En savoir plus sur l'efficacité et les bénéfices des soins chiropratiques"
                        >
                            En savoir plus
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Intro;
